import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {BlogCategoryState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class BlogCategoryQuery extends QueryEntity<BlogCategoryState> {

  constructor(protected store: Store) {
    super(store);
  }

}
